module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Ge-Hc-Ic-Ja.b4041f8d.png";